import * as React from 'react';

function SvgHelpCircleOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M12 2a10 10 0 100 20 10 10 0 000-20z" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeMiterlimit: 10, strokeWidth: 1.6, d: "M8.818 8.949s.048-.995 1.112-1.851c.631-.509 1.388-.656 2.07-.666.62-.008 1.175.095 1.507.253.568.27 1.675.93 1.675 2.335 0 1.477-.966 2.148-2.067 2.886-1.1.738-1.4 1.54-1.4 2.367" }),
        React.createElement("path", { fill: "currentColor", d: "M11.659 18.363a1.136 1.136 0 100-2.272 1.136 1.136 0 000 2.272z" })));
}

export default SvgHelpCircleOutline;
